var React = require('react');

function InfoConciergeInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"square","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"},[React.createElement("circle",{"cx":"12","cy":"12","r":"11","key":0}),React.createElement("path",{"d":"M12 11v6m0-10v1","key":1})]));
}

InfoConciergeInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = InfoConciergeInline;

InfoConciergeInline.default = InfoConciergeInline;
